import VividusAPI from "../../../apis/VividusAPI";
import QueryGetPermissionsGroupPaginatedDto from "../../../apis/VividusAPI/dto/QueryGetPermissionsGroupPaginatedDto";

export default class PermissionsGroupService {
	async list(query: QueryGetPermissionsGroupPaginatedDto = {}) {
		return VividusAPI.getPermissionsGroupPaginated(query);
	}
}
